import React, { useEffect, useState, useRef } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import Aside from "./Aside";
import { Link } from "react-router-dom";
import CampoNit from "../custom/CampoNit";
import { escalarImagen } from "../../../resources/Helper";
import ParametrosSuscripcionEpayco from "../settings/ParametrosSuscripcionEpayco";

function CuentaForm() {
    
    const [id, setId] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [numColaboradores, setNumColaboradores] = useState('5');
    const [direccion, setDireccion] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('2');
    const [pais, setPais] = useState('Colombia');
    const [telefono, setTelefono] = useState('');
    const [identificacion, setIdentificacion] = useState('');
    const [tipoIdentificacion, setTipoIdentificacion] = useState('');
    const [plan, setPlan] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState();
    const [presentaRipsComoIps, setPresentaRipsComoIps] = useState(false);
    const [codigoUnicoIps, setCodigoUnicoIps] = useState('');
    const [logo, setLogo] = useState();
    const [logoData, setLogodata] = useState();
    
    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();
    const [client, setClient] = useState([]);
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');

    const [mensajePopup, setMensajePopup] = useState('Lorem ipsum dolor');
    const [claseMensajePopup, setClaseMensajePopup] = useState('alert alert-success mensaje-popup');

    const [headerCollapsed, setHeadercollapsed] = useState('collapse-hdr');
    let userdata = [];
    let history = useHistory();

    const [showToast, setShowToast] = useState(false);
    const [toastDelay, setToastDelay] = useState(4000);
    const [toastMessage, setToastMessage] = useState();
    const [pestanaActiva, setPestanaActiva] = useState('cuenta');
    const [puedeVerSuscripcion, setPuedeVerSuscripcion] = useState(false);

    const logoRef = useRef(0);
    const canvasRef = useRef(null);
    const logoInputRef = useRef(null);

    useEffect(() => {
      
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            const slugs = Array.isArray(userdata.permissions)
                ? userdata.permissions.map((p) => p.slug)
                : (userdata.up || []);
            setPuedeVerSuscripcion(slugs.includes('ver_suscripcion'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setId(response.data.client_id);
                    setNombreEmpresa(response.data.nombre);
                    setNumColaboradores(response.data.empleados);
                    setDireccion(response.data.direccion);
                    setTipoEmpresa(response.data.tipo_cliente);
                    setPais(response.data.pais);
                    setTelefono(response.data.telefono);
                    setIdentificacion(response.data.numero_documento);
                    setTipoIdentificacion(response.data.tipo_documento);
                    setPlan(response.data.plan);
                    setDigitoVerificacion(response.data.digito_verificacion);
                    setPresentaRipsComoIps(Number(response.data.presenta_rips_como_ips) === 1);
                    setCodigoUnicoIps(response.data.codigo_unico_ips || '');
                    setLogo(response.data.logo);

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
    },[]);


    useEffect(() => {
        if (pestanaActiva === 'cuenta') {
            renderLogo();
        }
    }, [logo, pestanaActiva]);


    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            nombre: nombreEmpresa,
            empleados: numColaboradores,
            direccion: direccion,
            tipo_cliente: tipoEmpresa,
            pais: pais,
            telefono: telefono,
            numero_documento: identificacion,
            tipo_documento: tipoIdentificacion,
            id: id,
            digito_verificacion: digitoVerificacion,
            presenta_rips_como_ips: presentaRipsComoIps ? 1 : 0,
            codigo_unico_ips: presentaRipsComoIps ? codigoUnicoIps : '',
            logo: logo
        };


        axios.put('client', conf)
            .then(
                response => {
                    setErrorlist({});
                    setLoading(false);
                    setToastMessage('La Información De La Cuenta Ha Sido Modificada');
                    setToastDelay(4000);
                    setShowToast(true);
                }
            )
            .catch(
                err => {
                    console.log(err.response.data)

                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    function handleNit(valor, digitoVerificacion) {
        setIdentificacion(valor);
        setDigitoVerificacion(digitoVerificacion);
    }


    const agregarLogo = (files) => {

        let file = files[0];
        if (!file) {
            return;
        }

        if (file.size > (2 * 1024 * 1024)) {
            setErrorlist((prev) => ({ ...prev, logo: 'La imagen supera el tamaño permitido (2MB).' }));
            return;
        }

        if (!['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)) {
            setErrorlist((prev) => ({ ...prev, logo: 'Formato de imagen no soportado.' }));
            return;
        }

        setErrorlist((prev) => ({ ...prev, logo: undefined }));
        const f = URL.createObjectURL(file);
        
        const canvas = canvasRef.current;
        if (!canvas) {
            return;
        }

        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const img = new Image();

        img.onload = function() {
            if (!canvasRef.current) {
                return;
            }
            const imagenEscalada = escalarImagen(img.width, img.height, canvas.width, canvas.height);
            const coordX = Math.floor((canvas.width - imagenEscalada.ancho)/2);
            const coordY = Math.floor((canvas.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, coordX, coordY, imagenEscalada.ancho, imagenEscalada.alto);
            setLogo(canvas.toDataURL());
        }

        img.src = f;
    }


    const renderLogo = () => {
        const canvas = canvasRef.current;
        if (!canvas || !logo) {
            return;
        }

        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const img = new Image();

        img.onload = function() {
            if (!canvasRef.current) {
                return;
            }
            const imagenEscalada = escalarImagen(img.width, img.height, canvas.width, canvas.height);
            const coordX = Math.floor((canvas.width - imagenEscalada.ancho)/2);
            const coordY = Math.floor((canvas.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, coordX, coordY, imagenEscalada.ancho, imagenEscalada.alto);
        }

        img.src = logo;
    }



    return (
      <div className="hold-transition">
        <Header client={client} />
        <Aside client={client} activelink="settings" />
        
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                <li className="breadcrumb-item" key="k1"><Link to="/settings">Configuración</Link></li>
                                <li className="breadcrumb-item" key="k2">Cuenta De Usuario</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <h1 className="m-0">Configurar Empresa / Profesional Independiente</h1>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content" >
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <style>{`
                                .cuenta-tabs-wrap { margin-bottom: 0; }
                                .cuenta-tabs.nav-tabs {
                                    border-bottom: 1px solid #e8ecef;
                                    gap: 8px;
                                    flex-wrap: wrap;
                                }
                                .cuenta-tabs .nav-item { margin-bottom: -1px; }
                                /* Anula custom.css (.nav-link:hover con fondo oscuro y !important) */
                                .cuenta-tabs .nav-link {
                                    cursor: pointer;
                                    border: 1px solid #e8ecef;
                                    border-radius: 12px 12px 0 0;
                                    color: #495057 !important;
                                    background-color: #f8f9fa !important;
                                    padding: 12px 20px;
                                    font-weight: 600;
                                    font-size: 0.95rem;
                                    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
                                    font-family: inherit;
                                    line-height: 1.35;
                                    margin: 0;
                                    box-shadow: none !important;
                                }
                                .cuenta-tabs .nav-link i {
                                    color: #495057 !important;
                                    opacity: 0.9;
                                }
                                .cuenta-tabs button.nav-link:focus {
                                    outline: none;
                                    box-shadow: 0 0 0 2px rgba(23, 162, 184, 0.25) !important;
                                }
                                .cuenta-tabs .nav-link:hover,
                                .cuenta-tabs .nav-link:focus-visible {
                                    color: #117a8b !important;
                                    background-color: #f1f5f9 !important;
                                    border-color: #dee2e6 !important;
                                    box-shadow: none !important;
                                }
                                .cuenta-tabs .nav-link:hover i,
                                .cuenta-tabs .nav-link:focus-visible i {
                                    color: #117a8b !important;
                                }
                                .cuenta-tabs .nav-link.active {
                                    color: #0d5c6b !important;
                                    background-color: #fff !important;
                                    border-color: #e8ecef #e8ecef #fff !important;
                                    border-bottom: 1px solid #fff !important;
                                    box-shadow: 0 -2px 0 #17a2b8 inset !important;
                                }
                                .cuenta-tabs .nav-link.active i {
                                    color: #0d5c6b !important;
                                }
                                .cuenta-tabs .nav-link.active:hover,
                                .cuenta-tabs .nav-link.active:focus-visible {
                                    color: #0d5c6b !important;
                                    background-color: #fff !important;
                                    border-color: #e8ecef #e8ecef #fff !important;
                                    box-shadow: 0 -2px 0 #17a2b8 inset !important;
                                }
                                .cuenta-tabs .nav-link.active:hover i,
                                .cuenta-tabs .nav-link.active:focus-visible i {
                                    color: #0d5c6b !important;
                                }
                                .horarios-info-banner,
                                .horarios-ejemplo-tip {
                                    font-size: 1rem;
                                    line-height: 1.55;
                                }
                                .horarios-info-banner {
                                    border-radius: 10px;
                                    padding: 0.85rem 1.1rem;
                                }
                                .horarios-info-banner i {
                                    font-size: 1em;
                                    vertical-align: -0.06em;
                                }
                                .horarios-ejemplo-tip {
                                    margin-bottom: 0;
                                    padding: 0.85rem 1.1rem;
                                    border-radius: 10px;
                                    background-color: #fdf8f1 !important;
                                    border: 1px solid #ebe3d6 !important;
                                    color: #5a5349 !important;
                                    box-shadow: none;
                                }
                                .horarios-ejemplo-tip strong {
                                    color: #454038;
                                    font-weight: 600;
                                }
                                .cuenta-form-layout {
                                    align-items: stretch;
                                }
                                .cuenta-rips-panel {
                                    margin-top: 1.5rem;
                                    padding: 1.25rem 1.35rem;
                                    border: 1px dashed #cfd8dc;
                                    border-radius: 12px;
                                    background: #f8fafb;
                                }
                                .cuenta-rips-panel__title {
                                    font-size: 0.95rem;
                                    font-weight: 600;
                                    color: #37474f;
                                    margin-bottom: 1rem;
                                }
                                .cuenta-logo-panel {
                                    min-height: 240px;
                                    padding: 1rem;
                                    border-radius: 12px;
                                    background: #eceff1;
                                    display: flex;
                                    flex-direction: column;
                                }
                                .cuenta-logo-panel .contenedor-logo-cliente {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                }
                                .cuenta-logo-panel .contenedor-imagen-logo {
                                    flex: 1;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background: #fff;
                                    border: 1px dashed #b0bec5;
                                    border-radius: 8px;
                                    margin-bottom: 0.75rem;
                                    min-height: 180px;
                                    position: relative;
                                }
                                .cuenta-logo-panel .logo-cliente-control {
                                    position: absolute;
                                    width: 0;
                                    height: 0;
                                    opacity: 0;
                                    overflow: hidden;
                                    pointer-events: none;
                                }
                                .cuenta-logo-panel .lbl-cargar-foto-perfil {
                                    cursor: pointer;
                                    margin-bottom: 0;
                                }
                                .cuenta-form-actions {
                                    display: flex;
                                    justify-content: flex-end;
                                    gap: 0.75rem;
                                    margin-top: 1.5rem;
                                }
                            `}</style>

                            <div className="cuenta-tabs-wrap">
                                <ul className="nav nav-tabs cuenta-tabs" role="tablist">
                                    <li className="nav-item">
                                        <button
                                            type="button"
                                            className={`nav-link${pestanaActiva === 'cuenta' ? ' active' : ''}`}
                                            onClick={() => setPestanaActiva('cuenta')}
                                        >
                                            <i className="fas fa-building mr-2"></i>Cuenta
                                        </button>
                                    </li>
                                    {puedeVerSuscripcion && (
                                        <li className="nav-item">
                                            <button
                                                type="button"
                                                className={`nav-link${pestanaActiva === 'suscripcion' ? ' active' : ''}`}
                                                onClick={() => setPestanaActiva('suscripcion')}
                                            >
                                                <i className="fas fa-credit-card mr-2"></i>Suscripción
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            {puedeVerSuscripcion && (
                                <div
                                    className={`card border-top-0${pestanaActiva === 'suscripcion' ? '' : ' d-none'}`}
                                    style={{ borderRadius: '0 0 12px 12px' }}
                                >
                                    <div className="card-body">
                                        <ParametrosSuscripcionEpayco embedded />
                                    </div>
                                </div>
                            )}
                            <form
                                id="role-form"
                                onSubmit={handleSubmit}
                                autoComplete="off"
                                className={pestanaActiva === 'cuenta' || !puedeVerSuscripcion ? '' : 'd-none'}
                            >
                                <div className="card">
                                    <div id="infobasica">
                                        <div className="card-body">
                                            <div className="row cuenta-form-layout">
                                                <div className="col-lg-8">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="companyName">Nombre / Razon Social</label>
                                                                <input type="text" name="company-name" className="form-control" id="companyName" defaultValue={nombreEmpresa} onChange={(e) => setNombreEmpresa(e.target.value)} />
                                                                <div className="invalid-feedback visible">{errorlist.nombre}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="companyType">Tipo De Empresa</label>
                                                                <select name="company-type" className="form-control" id="companyType" value={tipoEmpresa} onChange={(e) => setTipoEmpresa(e.target.value)}>
                                                                    <option value="1">Consultorio Medico</option>
                                                                    <option value="2">Consultorio Odontológico</option>
                                                                    <option value="3">Clínica Estetica</option>
                                                                    <option value="4">Clínica Dermatologica</option>
                                                                    <option value="5">Centro De Vacunacion</option>
                                                                    <option value="6">SPA</option>
                                                                    <option value="4">Otro</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="tipoIdentificacion">Tipo Documento</label>
                                                                <select name="tipoIdentificacion" id="tipoIdentificacion" className="form-control" value={tipoIdentificacion} onChange={(e) => setTipoIdentificacion(e.target.value)}>
                                                                    <option value="NIT">NIT</option>
                                                                    <option value="CC">CC</option>
                                                                    <option value="TI">TI</option>
                                                                    <option value="CE">CE</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <CampoNit valor={identificacion} digitoVerificacion={digitoVerificacion} onChange={handleNit} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="phoneNumber">Número Celular</label>
                                                                <input type="text" name="phone-number" className="form-control" id="phoneNumber" placeholder="Número telefónico" defaultValue={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                                <div className="invalid-feedback visible">{errorlist.telefono}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                       

                                                    <div className="row">
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <label htmlFor="companyAddress">Dirección</label>
                                                                <input type="text" name="company-address" className="form-control" id="companyAddress" defaultValue={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                                <div className="invalid-feedback visible">{errorlist.direccion}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label htmlFor="country">País</label>
                                                                <select name="country" className="form-control" id="country" value={pais} onChange={(e) => setPais(e.target.value)}>
                                                                    <option value="Colombia">Colombia</option>
                                                                    <option value="Ecuador">Ecuador</option>
                                                                    <option value="Peru">Perú</option>
                                                                    <option value="Panama">Panamá</option>
                                                                    <option value="Otro">Otro</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="cuenta-rips-panel">
                                                        <div className="cuenta-rips-panel__title">Configuración RIPS</div>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group mb-md-0">
                                                                    <label className="d-block">¿Presenta RIPS como IPS?</label>
                                                                    <div className="btn-group btn-group-toggle" data-toggle="buttons">
                                                                        <label className={`btn btn-outline-info${presentaRipsComoIps ? ' active' : ''}`}>
                                                                            <input
                                                                                type="radio"
                                                                                name="presenta-rips-ips"
                                                                                checked={presentaRipsComoIps}
                                                                                onChange={() => setPresentaRipsComoIps(true)}
                                                                            />{' '}
                                                                            Sí
                                                                        </label>
                                                                        <label className={`btn btn-outline-secondary${!presentaRipsComoIps ? ' active' : ''}`}>
                                                                            <input
                                                                                type="radio"
                                                                                name="presenta-rips-ips"
                                                                                checked={!presentaRipsComoIps}
                                                                                onChange={() => {
                                                                                    setPresentaRipsComoIps(false);
                                                                                    setCodigoUnicoIps('');
                                                                                }}
                                                                            />{' '}
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                    <small className="form-text text-muted mt-2">
                                                                        Indique si la institución reporta RIPS como IPS ante el sistema de salud.
                                                                    </small>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                {presentaRipsComoIps ? (
                                                                    <div className="form-group mb-md-0">
                                                                        <label htmlFor="codigoUnicoIps">Código único IPS</label>
                                                                        <input
                                                                            type="text"
                                                                            name="codigo-unico-ips"
                                                                            className={`form-control${errorlist.codigo_unico_ips ? ' is-invalid' : ''}`}
                                                                            id="codigoUnicoIps"
                                                                            maxLength={20}
                                                                            value={codigoUnicoIps}
                                                                            onChange={(e) => setCodigoUnicoIps(e.target.value)}
                                                                            placeholder="Ej. 0500100001"
                                                                        />
                                                                        <div className="invalid-feedback visible">
                                                                            {errorlist.codigo_unico_ips}
                                                                        </div>
                                                                        <small className="form-text text-muted">
                                                                            Se usa como codPrestador. El NIT de la empresa se envía como documento del obligado.
                                                                        </small>
                                                                    </div>
                                                                ) : (
                                                                    <div className="text-muted small pt-md-2">
                                                                       
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-4 mt-4 mt-lg-0">
                                                    <div className="cuenta-logo-panel">
                                                        <div className="form-group mb-0 flex-grow-1 d-flex flex-column">
                                                            <label htmlFor="logoEmpresa">Logo De La Empresa</label>
                                                            <div className="contenedor-logo-cliente">
                                                                <div className="contenedor-imagen-logo">
                                                                    <canvas id="myCanvas" className="logo-cliente" width="240" height="180" ref={canvasRef} />
                                                                    <input
                                                                        type="file"
                                                                        ref={logoInputRef}
                                                                        name="logoimg"
                                                                        id="logoimg"
                                                                        className="logo-cliente-control"
                                                                        accept=".jpg,.png,.jpeg,.webp,.gif"
                                                                        onChange={(e) => agregarLogo(e.target.files)}
                                                                    />
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="lbl-cargar-foto-perfil btn btn-info btn-block"
                                                                    onClick={() => logoInputRef.current?.click()}
                                                                >
                                                                    Cargar Imagen
                                                                </button>
                                                                <div className="invalid-feedback visible">{errorlist.logo}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="cuenta-form-actions">
                                    <Link to="/settings" className="btn btn-light border">
                                        Cancelar
                                    </Link>
                                    <button type="submit" className="btn btn-primary">
                                        Guardar Cambios&nbsp;
                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                    </button>
                                </div>

                            </form>

                        </div>          
                    </div>

                </div>
            </section>
            
        </div>
        
        <div className={claseMensajePopup}>{mensajePopup}</div>

        <Footer showToast={showToast} delay={toastDelay} message={toastMessage} />
      </div>
    );
}
export default CuentaForm;